/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { GridHeaderCell as o } from "../GridHeaderCell.mjs";
const a = (e) => /* @__PURE__ */ r.createElement(o, { ...e });
export {
  a as GridHeaderRowReorderCell
};
